import { appInfo } from "@/mocks/homeData";

export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 order-2 lg:order-1">
            <div className="max-w-[300px] mx-auto lg:mx-0">
              <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-background-200 relative">
                <img
                  src={appInfo.image}
                  alt="黄桃视频移动端体验"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
              {appInfo.title}
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0">
              {appInfo.description}
            </p>

            <div className="grid grid-cols-2 gap-3 max-w-md mx-auto lg:mx-0">
              {appInfo.features.map((f, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 bg-background-50 rounded-lg px-4 py-3 border border-background-200/60"
                >
                  <div className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-primary-600 text-xs"></i>
                  </div>
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">
                    {f}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}